import { render, staticRenderFns } from "./CouponCaption.vue?vue&type=template&id=bd945a48&scoped=true"
import script from "./CouponCaption.vue?vue&type=script&lang=js"
export * from "./CouponCaption.vue?vue&type=script&lang=js"
import style0 from "./CouponCaption.vue?vue&type=style&index=0&id=bd945a48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd945a48",
  null
  
)

export default component.exports